import React from 'react'
import Base  from 'components/base'
import { Provider } from 'react-redux'
import { hot } from 'react-hot-loader'
import store from 'state/index.js'
import config from 'config'
import {
  validate,
} from 'state/actions'

function App(props) {
	var uid = window.location.search.split("?")
	if(uid[1]){
		store.dispatch(validate(uid[1]))
	}
  return (
    <Provider store={store}>
      <Base />
    </Provider>
  )
}

export default hot(module)(App)


// WEBPACK FOOTER //
// ./app.js